import { useState } from 'react';
import { Popover } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { Declaration } from 'store/declarations/declaration';
import MirroredDeclarationsPopoverContent from './MirroredDeclarationsPopoverContent';
import { LinksPill } from './styles';
import { stopRowClick } from './stopRowClick';
import { useMirroredDeclarationsOnOpen } from './useMirroredDeclarationsOnOpen';

type Props = {
    declaration: Declaration;
    label: string;
    manifestId?: string;
    jobId?: string;
};

const MirroredLinksPill = ({ declaration, label, manifestId, jobId }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const { declarations, isLoading, hasError } = useMirroredDeclarationsOnOpen(declaration, isOpen);

    const content = (
        <div onClick={stopRowClick}>
            <MirroredDeclarationsPopoverContent
                declarations={declarations}
                isLoading={isLoading}
                hasError={hasError}
                manifestId={manifestId}
                jobId={jobId}
            />
        </div>
    );

    return (
        <Popover
            title="Linked Declarations"
            trigger="click"
            open={isOpen}
            onOpenChange={setIsOpen}
            content={content}
            overlayInnerStyle={{ borderRadius: 6 }}
        >
            <LinksPill type="button" onClick={stopRowClick} data-testid="declaration-mirror-links">
                <LinkOutlined style={{ fontSize: 14 }} />
                {label}
            </LinksPill>
        </Popover>
    );
};

export default MirroredLinksPill;
